import Vue from 'vue';
import GoogleAuth from '@/components/auth/oauth/google_oAuth.js'

const gauthOption = {
    clientId: '207667194184-dtrcsada2tmf9o83np6rur1d05gf1ff2.apps.googleusercontent.com',
    scope: 'profile email',
    prompt: 'select_account'
}

Vue.use(GoogleAuth, gauthOption)
